import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { extrairErro } from '../services/api';
import { IconArrowLeft, IconAlert } from '../components/icons';

function Acompanhamento() {
  const navigate = useNavigate();
  const [protocolo, setProtocolo] = useState('');
  const [pin, setPin] = useState('');
  const [caso, setCaso] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [excluindo, setExcluindo] = useState(false);
  const [excluido, setExcluido] = useState(false);

  const handleBuscar = async (e) => {
    e.preventDefault();
    if (!protocolo || !pin) {
      setError('Protocolo e PIN são obrigatórios');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      // PIN vai no corpo, nunca na URL: query string vaza em log de proxy, histórico e Referer.
      const res = await api.post('/public/acompanhamento', { protocolo, pin });
      setCaso(res.data);
    } catch (err) {
      setError(extrairErro(err, 'Denúncia não encontrada'));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = async () => {
    if (!window.confirm(
      'Isso apaga permanentemente a descrição, envolvidos, testemunhas e evidências desta denúncia. ' +
      'O protocolo continua existindo só para estatística, sem nenhum dado identificável. Não há como desfazer. Confirma?'
    )) {
      return;
    }
    setExcluindo(true);
    setError(null);
    try {
      await api.post('/public/lgpd/exclusao', { protocolo, pin });
      setExcluido(true);
      setCaso(null);
    } catch (err) {
      setError(extrairErro(err, 'Não foi possível excluir os dados agora'));
    } finally {
      setExcluindo(false);
    }
  };

  if (excluido) {
    return (
      <div className="container">
        <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>
        <div className="step-heading">
          <h2>Dados removidos</h2>
          <p className="info-text">
            Seus dados foram removidos a seu pedido. O protocolo {protocolo} deixa de ter descrição,
            envolvidos, testemunhas ou evidências associadas.
          </p>
        </div>
      </div>
    );
  }

  if (caso) {
    return (
      <div className="container">
        <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>
        <div className="step-heading">
          <p className="eyebrow">Ouvir · Proteger · Construir juntos</p>
          <h2>Status da sua denúncia</h2>
        </div>

        <div className="status-container">
          <div className="status-item">
            <label>Protocolo:</label>
            <p className="status-value">{caso.protocolo}</p>
          </div>

          <div className="status-item">
            <label>Status:</label>
            <p className="status-badge">{caso.status_label || caso.status}</p>
          </div>

          <div className="status-item">
            <label>Categoria:</label>
            <p>{caso.categoria}</p>
          </div>

          <div className="status-item">
            <label>Recebida em:</label>
            <p>{new Date(caso.recebida_em).toLocaleDateString('pt-BR')}</p>
          </div>

          {caso.descricao && (
            <div className="status-item">
              <label>Descrição:</label>
              <p>{caso.descricao}</p>
            </div>
          )}

          {caso.resposta && (
            <div className="status-item resposta">
              <label>Resposta:</label>
              <p>{caso.resposta}</p>
            </div>
          )}
        </div>

        <button className="btn btn-secondary" onClick={() => {
          setCaso(null);
          setProtocolo('');
          setPin('');
        }}>
          Buscar Outra Denúncia
        </button>

        <button
          className="btn btn-link"
          onClick={handleExcluir}
          disabled={excluindo}
          style={{ marginTop: '1rem' }}
        >
          {excluindo ? 'Excluindo...' : 'Solicitar exclusão dos meus dados'}
        </button>
      </div>
    );
  }

  return (
    <div className="container">
      <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>
      <div className="step-heading">
        <p className="eyebrow">Ouvir · Proteger · Construir juntos</p>
        <h2>Acompanhar denúncia</h2>
        <p className="info-text">Digite o protocolo e PIN da sua denúncia para acompanhar o status.</p>
      </div>

      <form onSubmit={handleBuscar} className="form">
        {error && <div className="error-message"><IconAlert />{error}</div>}

        <div className="form-group">
          <label htmlFor="protocolo">Protocolo</label>
          <input
            id="protocolo"
            type="text"
            placeholder="Ex: GV2026000000"
            value={protocolo}
            onChange={(e) => setProtocolo(e.target.value.toUpperCase())}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="pin">PIN</label>
          <input
            id="pin"
            type="password"
            placeholder="Digite o PIN fornecido"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? 'Buscando...' : 'Buscar'}
        </button>
      </form>
    </div>
  );
}

export default Acompanhamento;
